
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { IoIosClose } from "react-icons/io";

import { Container, Close, BoxImage, BoxInfor, ItemMenu, BoxMenu } from "./styled";
import { useState } from 'react';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { translations } from '../../../../utils/language';
import { ArrowDownOnSquareIcon, ArrowPathIcon, ArrowPathRoundedSquareIcon, ArrowTopRightOnSquareIcon, CloudArrowUpIcon, CodeBracketIcon, EnvelopeIcon, LinkIcon, PaperClipIcon, EyeIcon } from '@heroicons/react/24/outline';
import { useHistory } from 'react-router-dom';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: "white",
        padding: "0px",
        margin: "0px",
        borderRadius: "10px"
    },
    overlay: {
        backgroundColor: "rgba(10,23,55,0.5)",
        zIndex: "99999999"
    }
};



const ModalMenuVariant = (props) => {

    const dispatch = useDispatch()
    const language = useSelector((state) => state.reducerLanguage);
    const history = useHistory()
    //const statusSendEmail = useSelector((state) => state.reducerEmails);

    const sendEmail = () => {
        // dispatch({
        //     type: "SAGA_RESEND_EMAIL",
        //     payload: { order: props.item },
        // });
    }

    // useEffect(() => {
    //     if (statusSendEmail.loading == false && statusSendEmail.error == false && statusSendEmail?.data?.length == 0) {

    //     } else {
    //         const id = "statusSendEmail"
    //         if (statusSendEmail.loading) {
    //             toast.loading(translations["Aguarde..."][language.data], { toastId: id })
    //         } else {
    //             if (statusSendEmail.error) toast.update(id, { render: "Erro ao tentar enviar.", type: "error", isLoading: false, hideProgressBar: false, autoClose: 3000, closeOnClick: true });
    //             else {
    //                 props.setVisibleModal(false)
    //                 toast.update(id, { render: translations["sales-enviado-sucesso"][language.data], type: "success", isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true })
    //             }
    //         }
    //     }
    // }, [statusSendEmail])

    const sincProduct = () => {
        dispatch({
            type: "SAGA_UPDATE_DATA_PRODUCT",
            payload: {
                integration: JSON.parse(localStorage.getItem("depoimentos@login"))?.integration,
                product: props.item.products,

            }
        })
    }
    const reducerControlVariants = useSelector(state => state.reducerControlVariants)
    useEffect(() => {
        // console.log("reducerControlVariants", reducerControlVariants)
    }, [reducerControlVariants])

    useEffect(() => {
        console.log("teste props menu variantes", props)
    }, [props])


    return (
        <Modal
            isOpen={props.visible}
            style={customStyles}
            ariaHideApp={false}
            onRequestClose={() => { props.setVisibleModal(false) }}
        >
            <Container>
                <Close onClick={() => { props.setVisibleModal(false) }}><IoIosClose size={25} color={"gray"} /></Close>
                <BoxMenu>

                    <Item
                        image={<CloudArrowUpIcon style={{ width: "32px" }} />}
                        action={() => {
                            //props.setVisibleModalUpload(true)
                            props.setVisibeModalAnexoNew(true)
                            props.setVisibleModal(false)

                            props.setVisibeModalAnexoNew(true)
                            console.log("props.item", props.item)
                            dispatch({ type: "VARIANTS_CONTROL_ADD", payload: [props.item] });

                            //history.push(`produtos/${props.item.products.product_id}/variacoes`); props.setVisibleModal(false)
                        }}
                        item={props.item}
                        title={translations["Anexar arquivos"][language.data]}
                        desc={translations["variants-menu-anexar-arquivos-desc"][language.data]} />

                    <Item
                        image={<ArrowTopRightOnSquareIcon style={{ width: "32px" }} />}
                        action={() => {
                            // sincProduct(); props.setVisibleModal(false)

                            //props.setVisibleModalConectar(true)
                            props.setVisibleModal(false)
                            props.setVisbleModalCadLinkNew(true)
                            dispatch({ type: "VARIANTS_CONTROL_ADD", payload: [props.item] });
                        }}
                        item={props.item}
                        title={translations["products-anexar-link"][language.data]}
                        desc={translations["variants-menu-anexar-link-desc"][language.data]} />

                    <Item
                        image={<LinkIcon style={{ width: "32px" }} />}
                        action={() => {
                            //sincProduct(); props.setVisibleModal(false) 
                            //props.setVisibleModalVincular(true)
                            props.setVisibleModal(false)
                            props.setVisbleModalAnexarGaleriaNew(true)
                            props.goSearchFiles()
                            dispatch({ type: "VARIANTS_CONTROL_ADD", payload: [props.item] });
                            props.setDataFilesTrue(props.item.media)
                        }}
                        item={props.item}
                        title={translations["products-anexar-galeria"][language.data]}
                        desc={translations["variants-menu-anexar-galeria-desc"][language.data]} />

                    <Item
                        image={<EyeIcon style={{ width: "32px" }} />}
                        action={() => {
                            props.setVisibleModal(false)
                            props.setVisibleModalUploadPreview(true)
                            dispatch({ type: "VARIANTS_CONTROL_ADD", payload: [props.item] });
                        }}
                        item={props.item}
                        title={translations["variants-menu-upload-preview"][language.data]}
                        desc={translations["variants-menu-upload-preview-desc"][language.data]} />

                    {JSON.parse(localStorage.getItem("depoimentos@login"))?.user?.id == 1167 || JSON.parse(localStorage.getItem("depoimentos@login"))?.user?.id == 1098 || JSON.parse(localStorage.getItem("depoimentos@login"))?.user?.id == 9337 ?
                        <Item
                            image={<CodeBracketIcon style={{ width: "32px" }} />}
                            action={() => {
                                props.setVisibleModal(false)
                                props.setVisbleModalAnexarLicenses(true)
                                props.goSearchLicenses()
                                dispatch({ type: "VARIANTS_CONTROL_ADD", payload: [props.item] });
                                props.setDataFilesTrue(props.item.variants.variantLinkLicenses)
                            }}
                            item={props.item}
                            title={translations["variants-menu-anexar-licenca"][language.data]}
                            desc={translations["variants-menu-anexar-licenca-desc"][language.data]} />
                        : null
                    }
                </BoxMenu>
            </Container>
        </Modal>
    )
}

export default ModalMenuVariant


const Item = (props) => {

    const dispatch = useDispatch()

    useEffect(() => {
        //console.log("props_", props)
    }, [props])


    const [hover, setHover] = useState(false)


    return (
        <ItemMenu onClick={() => { props.action() }} hover={hover} onMouseLeave={() => { setHover(false) }} onMouseEnter={() => { setHover(true) }}>
            <BoxImage hover={hover}>
                {props.image}
            </BoxImage>
            <BoxInfor>
                <label>{props.title}</label>
                <p>{props.desc}</p>
            </BoxInfor>
        </ItemMenu>
    )
}

